var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M68.6012 78H8.0466C3.60612 78 0 74.0339 0 69.1502V35.897C0 33.6729 1.64043 31.8687 3.66269 31.8687H72.9851C75.0073 31.8687 76.6478 33.6729 76.6478 35.897V69.1502C76.6478 74.0339 73.0416 78 68.6012 78ZM4.2425 36.5347V69.1502C4.2425 71.4521 5.93949 73.334 8.0466 73.334H68.6153C70.7083 73.334 72.4194 71.4676 72.4194 69.1502V36.5347H4.2425Z",
  fill: "#275B57"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M67.1728 36.5354H9.4749L0 21.3241V19.0533C0 17.4669 1.17376 16.1604 2.63035 16.1604H74.0315C75.474 16.1604 76.6619 17.4513 76.6619 19.0533V21.3241L67.1728 36.5354ZM11.7093 31.8693H64.9384L71.8113 20.8264H4.83644L11.7093 31.8693Z",
  fill: "#275B57"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M74.0182 20.826H2.6312L0.835205 17.2487L6.78884 6.90571C9.27777 2.58187 13.5344 0 18.187 0H58.4624C63.115 0 67.3717 2.58187 69.8606 6.90571L75.8142 17.2487L74.0182 20.826ZM6.47773 16.16H70.1576L66.2686 9.4098C64.5575 6.45466 61.6443 4.68157 58.4483 4.68157H18.187C15.0051 4.68157 12.0778 6.45466 10.3667 9.4098L6.47773 16.16Z",
  fill: "#275B57"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M48.4345 34.2025V53.0999C48.4345 56.7705 45.7193 59.7568 42.3818 59.7568H34.2645C30.9271 59.7568 28.2119 56.7705 28.2119 53.0999V34.2025H48.4345Z",
  fill: "#275B57"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M39.5121 52.4918H37.2494C37.0656 52.4918 36.9383 52.4451 36.8676 52.3673C36.7828 52.274 36.7545 52.134 36.7545 51.9474V44.4195H34.7039C34.5342 44.4195 34.3928 44.3729 34.3221 44.2951C34.2373 44.2018 34.209 44.0618 34.209 43.8751V42.0087C34.209 41.8221 34.2514 41.6665 34.3221 41.5888C34.407 41.4955 34.5342 41.4644 34.7039 41.4644H42.0717C42.2414 41.4644 42.3829 41.511 42.4536 41.5888C42.5384 41.6821 42.5667 41.8221 42.5667 42.0087V43.8596C42.5667 44.0618 42.5243 44.2018 42.4536 44.2795C42.3687 44.3729 42.2414 44.404 42.0717 44.404H40.0212V51.9318C40.0212 52.134 39.9788 52.274 39.9081 52.3518C39.8091 52.4606 39.6818 52.4918 39.5121 52.4918Z",
  fill: "#E8B303"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M44.5031 9.81421H32.1574C29.9796 9.81421 28.2119 11.7584 28.2119 14.1536V16.1911H48.4345V14.1536C48.4345 11.7584 46.6668 9.81421 44.5031 9.81421Z",
  fill: "#E8B303"
});

function SvgLogoLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 78,
    viewBox: "0 0 77 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo_light.566ddf9a57a5fad251853b5c763841df.svg";
export { ForwardRef as ReactComponent };